import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"
import AuthLoader from './AuthLoader'

const DeleteModal = ({ show, onDeleteClick, onCloseClick, okBtnName,cancelBtnName, content,loader }) => {
  return (
    <Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content p-0 border-0 client">
        <ModalBody className="px-2 py-2 text-center">
          <button type="button" onClick={onCloseClick} className="btn-close"></button>
          {/* <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div> 
          </div> */}
          <h2 className='mb-0 mb-2'>Confirmation</h2>
          <p className="text-muted font-size-16 mb-4">{content}</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button type="button" className="secountry-btn" onClick={onCloseClick}>{cancelBtnName}</button> 
            {loader ? <AuthLoader/> : <button type="button" className="primary-button" onClick={onDeleteClick}>{okBtnName}</button>}
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any
}

export default DeleteModal
